<template>
  <div class="jb_detail" :class="{'active': jb_data}">
    <Menu v-if="$route.query.p !== 'app'" />
    <div v-if="jb_data" class="jb_detail_bx">
      <h3 class="jb_title">{{jb_data.tilte}}</h3>
      <div class="jb_location">
        <img class="jb_location_icon" src="@/assets/join/location_icon.svg" alt="">
        <p class="jb_cities" v-for="(lo_item,lo_index) in jb_data.city" :key="lo_index"><span>{{lo_item}}</span><span class="xg">/</span></p>
      </div>
      <p class="line"></p>
      <div class="jb_item">
        <p class="jb_item_title">岗位职责</p>
        <p class="ib_item_desc" v-for="(du_item,du_index) in jb_data.duty" :key="du_index">{{du_item}}</p>
      </div>
      <div class="jb_item">
        <p class="jb_item_title">任职要求</p>
        <p class="ib_item_desc" v-for="(rp_item,rp_index) in jb_data.responsibility" :key="rp_index">{{rp_item}}</p>
      </div>
      <div class="jb_item" v-if="jb_data.priorityConditions">
        <p class="jb_item_title">有以下工作经验者优先</p>
        <p class="ib_item_desc" v-for="(pc_item,pc_index) in jb_data.priorityConditions" :key="pc_index">{{pc_item}}</p>
      </div>
    </div>
    <div v-else>
      <div class="no_data">
        <img class="empty_img" src="@/assets/join/empty.svg" alt="">
        <p class="empty_info" v-if="loading">加载中...</p>
        <p class="empty_info" v-else>职位不存在</p>
      </div>
    </div>
    <Footer />
    <div v-if="jb_data" class="jb_contact_bx">
      <div class="jb_contact">
        <p class="mail_info">
          <span class="text">投递邮箱：</span>
          <span class="text2 mail_info">recruit@zuler.io</span>
        </p>
        <p class="mention">*投递请注明应聘岗位-地点</p>
        <div class="copy" @click="copy('.copy')" data-clipboard-text="recruit@zuler.io">复制邮箱</div>
      </div>
    </div>
  </div>
</template>
<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
import Clipboard from 'clipboard'
import { Toast } from 'vant';
import axios from "axios";
export default {
  components: {
    Menu,
    Footer,
  },
  data(){
    return {
      jb_id: '',
      jb_data: null,
      loading:true
    }
  },
  mounted() {
    if(this.$route.query.id){
      this.jb_id = this.$route.query.id;
      this.getData()
    }
  },
  methods: {
    async getData() {
      try {
        // let res = await axios.get('/info/lib/e80f8f761fa2d1d0.json');
        let res = await axios.get(`${location.origin}/lib/e80f8f761fa2d1d0.json`);// 上线
        this.jobList = res.data;
        this.jb_data = this.jobList.find(item => {
          return item.jb_id == this.jb_id
        });
      } catch (err) {
        // console.log(err);
      }
      this.loading = false;
    },
    copy(className) {
      const _this = this;
      let clipboard = new Clipboard(className)
      clipboard.on('success', e => {
        Toast.success('复制成功');
        clipboard.destroy()
      })
      clipboard.on('error', e =>{
        Toast.fail('该浏览器不支持复制');
        clipboard.destroy()
      })
    }
  },
}
</script>
<style lang="less" scoped>
.jb_detail{
  &.active{
    padding-bottom: 130px;
  }
  .jb_detail_bx{
    padding: 30px 20px;
    background: #fff;
    .jb_title{
      font-size: 22px;
      font-weight: 500;
      line-height: 130%;
    }
    .jb_location{
      display: flex;
      align-items: center;
      margin-top: 6px;
      .jb_location_icon{
        width: 12px;
        height: 12px;
      }
      .jb_cities{
        align-items: center;
        margin-left: 7px;
        font-size: 14px;
        font-weight: 400;
        line-height: 130%;
        color: #444546;
        margin-right: -6px;
        .xg{
          margin-left: 2px;
        }
        &:last-of-type{
          .xg{
            display: none;
          }
        }
      }
    }
    .line{
      margin-top: 20px;
      width: 100%;
      height: 1PX;
      background-color: rgba(0, 0, 0, 0.05);
      margin-bottom: 20px;
    }
    .jb_item{
      margin-bottom: 30px;
      .jb_item_title{
        display: flex;
        align-items: center;
        font-weight: 500;
        line-height: 160%;
        letter-spacing: 1px;
        font-size: 16px;
        color: #444546;
        margin-bottom: 13px;
        &::before{
          display: inline-block;
          content: '';
          width: 3px;
          height: 16px;
          background: #0070F9;
          margin-right: 8px;
        }
      }
      .ib_item_desc{
        font-size: 14px;
        font-weight: 400;
        line-height: 187%;
        letter-spacing: 1px;
        color: #747576;
        margin-bottom: 5px;
      }
    }
  }
  .jb_contact_bx{
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 10;
    background-color: #fff;
  }
  .jb_contact{
    width: 100%;
    border-top: 1PX solid rgba(99, 103, 111, 0.11);
    padding: 8px 20px 12px;
    background: #fff;
    text-align: center;
    box-sizing: border-box;
    .mail_info{
      font-size: 15px;
      line-height: 160%;
      letter-spacing: 1px;
      .text{
        color: #444546;
        font-weight: 400;
      }
      .text2{
        font-weight: 500;
        color: #0070F9;
      }
    }
    .mention{
      margin-top: 3px;
      color: #616369;
      line-height: 160%;
      letter-spacing: 1px;
      font-size: 11px;
    }
    .copy{
      width: 100%;
      height: 46px;
      line-height: 45px;
      color: #fff;
      font-size: 16px;
      background: #0070F9;
      border-radius: 12px;
      text-align: center;
      margin-top: 7px;
      &:active{
        background: #338DFA;
      }
    }
  }
  .no_data{
    text-align: center;
    padding-top: 30px;
    padding-bottom: 30vh;
    .empty_img{
      width: 120px;
      height: 120px;
    }
    .empty_info{
      margin-top: 10px;
      font-size: 12px;
      color: #9E9E9F;
    }
  }
}
</style>
